import { GridPanelVm } from "../../panels/gridpanel-vm";
import { UrlHelper } from "../html/url-helper";
import { StateStoring } from "../settings/statestoring";
import { dx } from "../../devexpress/ui-options-types-wrapper";
import { DefaultSettings } from "../../devexpress/settings/defaultsettings";
import { FilterBuilder } from "../../devexpress/filter/filter-builder";
import { DiffType } from "../../extend/diff";
import { ControlType } from "../../devexpress/controltype";

export class DebuggingDiffDialogGridVm extends GridPanelVm<any> {
	private showChangesOnly = ko.observable(true);

	constructor() {
		super({ initialHeightPerc: 80 });

		this.applyGridOptions({
			dataSource: this.dataSource,
			stateStoring: StateStoring.createStateStoring(
				10,
				"DebuggingDiff",
				true,
				ControlType.DataGrid
			),
			dataStructure: "tree",
			columns: [
				{
					dataField: "source",
					dataType: "string",
					groupIndex: 0,
				},
				{
					dataField: "change",
					dataType: "string",
					alignment: "center",
					width: 50,
				},
				{
					dataField: "key",
					dataType: "string",
				},
				{
					dataField: "value",
					dataType: "string",
				},
			],
			keyExpr: "id",
			scrolling: { mode: "virtual" },
			selection: { mode: "none" },
			onToolbarPreparing: (e) => {
				let { toolbarItems } = DefaultSettings.appendToolbarItems(e);

				toolbarItems.unshift({
					widget: "dxCheckBox",
					options: {
						value: true,
						text: "Einträge expandieren",
						onValueChanged: (data: any) => {
							this.dataGridInstance.option("grouping.autoExpandAll", data.value);
						}
					},
					location: "before"
				});

				toolbarItems.unshift({
					widget: "dxCheckBox",
					options: {
						value: this.showChangesOnly,
						text: "Nur Änderungen anzeigen",
					},
					location: "before",
				});
			},
			filterValue: ko.pureComputed(() => {
				let builder = new FilterBuilder("and");
				if (this.showChangesOnly()) {
					builder.addExpression(["change", "<>", "="]);
				}
				return builder.getFilter();
			}),
			onRowPrepared: (e) => {
				if (e.rowType === "data") {
					switch (e.data && e.data.change) {
						case DiffType.Insertion:
							e.rowElement.css("background-color", "#AAFFB6");
							break;

						case DiffType.Deletion:
							e.rowElement.css("background-color", "#FFADAE");
							break;

						default:
							break;
					}
				}
			},
		} as dx.DataGridOptions);
	}

	public dataSource: KnockoutObservable<any> = ko.observable([]);
}